module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "unstyled-list"
  }, _vm._l((_vm.botones), function(bot, index) {
    return _c('li', {
      key: index
    }, [_c('button', {
      staticClass: "bot-slide animated flipInY",
      class: (_vm.botNumber === (index + 1) ? 'slide-active' : '') + ' ' + ('dura_' + index),
      attrs: {
        "id": 'bot-slide-' + index,
        "aria-label": bot.name + ' ' + (bot.visto ? 'Visto' : 'No visto')
      },
      on: {
        "click": function($event) {
          _vm.botClick(index, bot)
        }
      }
    }, [_c('div', {
      staticClass: "bot-slider"
    }, [_c('div', {
      staticClass: "botnum"
    }, [_vm._v("\n          " + _vm._s(index + 1) + "\n        ")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(bot.name))]), _vm._v(" "), _c('div', {
      staticClass: "bot-check"
    }, [(bot.visto) ? _c('image-app', {
      staticClass: "animated bounceIn",
      attrs: {
        "imaSize": 20,
        "imaSrc": "logos-icons/ok-bullet",
        "imaAlt": ""
      }
    }) : _vm._e()], 1)])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-601a4642","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/tabsButtonsSlideList.vue
// module id = 1031
// module chunks = 1